import { useEffect, useState } from 'react';

import clsx from 'clsx';

interface NumberStepperProps {
  values: number[];
  currentValue: number;
  onChange: (value: number) => void;
  className?: string;
  placeholder?: string;
  isDisabled?: boolean;
}

export const NumberStepper = ({
  values,
  currentValue,
  onChange,
  className = '',
  placeholder,
  isDisabled = false
}: NumberStepperProps) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const initialIndex = values.indexOf(currentValue);
    if (initialIndex !== -1) {
      setSelectedIndex(initialIndex);
    }
  }, [currentValue, values]);

  const handleChange = (newIdx: number) => {
    const newValue = values[newIdx];
    setSelectedIndex(newIdx);
    onChange(newValue);
  };

  const handleDecrement = () => {
    if (selectedIndex > 0) {
      handleChange(selectedIndex - 1);
    }
  };

  const handleIncrement = () => {
    if (selectedIndex < values.length - 1) {
      handleChange(selectedIndex + 1);
    }
  };

  return (
    <div
      className={clsx(
        'inline-flex items-center rounded-xl border border-blue-powder bg-white p-2',
        isDisabled && 'pointer-events-none select-none opacity-50',
        className
      )}>
      <button
        type='button'
        className='px-2 py-1 text-lg disabled:select-none disabled:opacity-50'
        onClick={handleDecrement}
        disabled={selectedIndex <= 0 || isDisabled}>
        &ndash;
      </button>
      <span className='select-none text-center'>{placeholder ? placeholder : currentValue}</span>
      <button
        type='button'
        className='px-2 py-1 text-lg disabled:select-none disabled:opacity-50'
        onClick={handleIncrement}
        disabled={selectedIndex >= values.length - 1 || isDisabled}>
        +
      </button>
    </div>
  );
};
